import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DealerReviewsInterface } from 'types/Apis/SearchURL';
import ReviewsLayout from '../Reviews/ReviewsLayout';
import AggregateCard from './AggregateCard';
import DealerReview from './DealerReview';
import Pagination from './Pagination';

interface DealerReviewsProps {
  locationDisplayName: string;
  reviews: DealerReviewsInterface;
}

export default function DealerReviews({
  locationDisplayName,
  reviews,
}: DealerReviewsProps): JSX.Element {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(reviews.pagination.currentPage);
  // will set state after calling API
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dealerReviews, setDealerReviews] = useState(reviews.dealerReviews);

  useEffect(() => {
    // call dealer reviews API to get the current page of dealer reviews
    // setDealerReviews with response to update displayed reviews
  }, [currentPage]);

  return (
    <>
      <ReviewsLayout
        header={`${locationDisplayName} ${t('seoSrp.dealerReviews.header')}`}
        summary={<AggregateCard reviewSummary={reviews.dealerReviewSummary} />}
        reviews={
          <>
            {dealerReviews.map((review) => (
              <DealerReview review={review} />
            ))}
          </>
        }
        pagination={
          <Pagination
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            pageCount={reviews.pagination.totalPages}
          />
        }
      />
    </>
  );
}
